export const isTokenExpired = (dateTimeExpiration: number) => {
  let isExpired = false;

  if (!dateTimeExpiration || Date.now() >= dateTimeExpiration) {
    isExpired = true;
  }

  return isExpired;
};

export const decodeJwt = (
  token: string
): { createdAt: number; expiration: number } | null => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    const payload = JSON.parse(jsonPayload);

    if (payload.iat && payload.exp) {
      const createdAt = payload.iat * 1000; // Convertendo de segundos para milissegundos
      const expiration = payload.exp * 1000; // Convertendo de segundos para milissegundos

      return {
        createdAt,
        expiration
      };
    }

    return null;
  } catch (error) {
    console.error('Erro ao decodificar o token:', error);
    return null;
  }
};
